import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { Calendar } from "primereact/calendar";

import React, { useEffect, useState } from "react";
import { updateCustomerOldOrderLedger } from "../../../services/CustomerInfo/OldOrder";
import { FloatLabel } from "primereact/floatlabel";
import { Dropdown } from "primereact/dropdown";
import SuccessModal from "../../SuccessModal";
import { getLocalPaymentMode, getUserData } from "../../../utils/localStorage";
import { getViewPaymentMode, getViewPaymentModeV2 } from "../../../services/paymentMode/paymentMode";

const OldOrderInfoEdit = ({
  oldOrderInfoEditVisible,
  setOldOrderInfoEditVisible,
  customerOrdersData,
  sendResponse,
  userProfileData,
}) => {

  const { userProfileRole } =
    getUserData();

  const userRole = userProfileRole;

  const [paidAmountValue, setPaidAmountValue] = useState("");
  const [receivedAmountValue, setReceivedAmountValue] = useState("");
  const [discountValue, setDiscountValue] = useState("");
  const [balanceAmountValue, setBalanceAmountValue] = useState("");
  const [statusValue, setStatusValue] = useState("");
  const [remarkValue, setRemarkValue] = useState("");
  const [statusSuggestionValue, setStatusSuggestionValue] = useState("");

  const [modalVisible, setModalVisible] = useState(false);
  const [modalStatus, setModalStatus] = useState(false);
  const [modalText, setModalText] = useState("");

  const [paymentMethodValue, setPaymentMethodValue] = useState("");
  const [paymentModeData, setPaymentModeData] = useState([]);
  const [isSubmitButtonPressed, setIsSubmitButtonPressed] = useState(false);

    const fetchPaymentMode = () => {
      getViewPaymentModeV2(customerOrdersData.brandId)
        .then((response) => {
          if (!response.data.error) {
            const Res = response.data?.paymentModes.filter(
              (item) => item !== "ONLINE" && item !== "USER_ACCOUNT" && item !== "ICICI_PG"
            );
            setPaymentModeData(Res);
          }
        })
        .catch((err) => {
          console.error("Error:", err);
        });
    };

   const fetchLocalPaymentMode = async () => {
    const { paymentMode } = getLocalPaymentMode();
    if (paymentMode && Object.keys(paymentMode).length > 0) {
      let filteredModes = [...paymentMode?.paymentModeList?.Location1];
      const ResWithoutPaymentGateway = filteredModes.filter(
        (item) => item !== "ONLINE" && item !== "USER_ACCOUNT" && item !== "ICICI_PG"
      );
      setPaymentModeData(ResWithoutPaymentGateway);
    } else {
      setPaymentModeData([]);
    }
  };

  const statusSuggestionData = [
    "PROCESSED",
    "DELIVERED",
    "DONE",
    "IN_WAREHOUSE",
  ];

  useEffect(() => {
    if (customerOrdersData !== null) {
      // setFirstNameValue(selectedUserItemValue?.firstName || '');

      setPaymentMethodValue(customerOrdersData?.paymentMode);
      setPaidAmountValue(customerOrdersData?.paidAmount || 0);
      setReceivedAmountValue(customerOrdersData?.receivedAmount || 0);
      setDiscountValue(0);
      setBalanceAmountValue(customerOrdersData?.balanceAmount || 0);
      setStatusValue(customerOrdersData?.status || 0);
      setRemarkValue(customerOrdersData?.remark || "");
    }
    if (userRole === "BY_STORE") {
      fetchLocalPaymentMode();
    } else {
      fetchPaymentMode()
    }
  }, [customerOrdersData]);

  const handleRemarkChange = (text) => {
    setRemarkValue(text);
  };

  const handleStatusChange = (text) => {
    setStatusValue(text);
  };

  const handleReceivedAmountChange = (text) => {
    if (text === "") {
      setErrorMessage("Receive Amount Can Not Be Empty.");
      setIsSubmitButtonPressed(true);
      setReceivedAmountValue(text);
    } else {
      const receivedAmount = parseFloat(text) || 0;
      setReceivedAmountValue(text);
      calculateBalanceAmount(receivedAmount, 0);
      setErrorMessage("");
      setIsSubmitButtonPressed(false);
    }
  };

  const handleDiscountChange = (text) => {
    if (text === "") {
      setErrorMessage("Discount Can Not Be Empty.");
      setIsSubmitButtonPressed(true);
      setDiscountValue(text);
    } else {
      const discount = parseFloat(text) || 0;
      setDiscountValue(text);
      calculateBalanceAmount(receivedAmountValue, discount);
      setErrorMessage("");
      setIsSubmitButtonPressed(false);
    }
  };

  const calculateBalanceAmount = (receivedAmount, discount) => {
    const calculatedBalance =
      parseInt(customerOrdersData?.balanceAmount) - receivedAmount - discount;
    setBalanceAmountValue(calculatedBalance.toString());
    if (calculatedBalance < 0) {
      setErrorMessage("Balance amount cannot be less than or equal to 0.");
      setIsSubmitButtonPressed(true);
    } else {
      setErrorMessage("");
      setIsSubmitButtonPressed(false);
    }
  };

  const handlePaymentMethodChange = (charge) => {
    if (charge === "") {
      setErrorMessage("Please Select Payment Method");
      setIsSubmitButtonPressed(true);
    } else {
      setPaymentMethodValue(charge);
      setErrorMessage("");
      setIsSubmitButtonPressed(false);
    }
  };

  const handleStatusSuggestionChange = (status) => {
    if (status === "") {
      setErrorMessage("Please Select Status");
      setIsSubmitButtonPressed(true);
    } else {
      // setStatusSuggestionValue(status);
      setStatusValue(status);
      setErrorMessage("");
      setIsSubmitButtonPressed(false);
    }
  };

  const [focusedField, setFocusedField] = useState("");

  const handleFocus = (field) => {
    setFocusedField(field);
  };

  const handleBlur = () => {
    setFocusedField("");
  };

  const [errorMessage, setErrorMessage] = useState("");

  const onUpdateButtonPress = () => {
    // Reset error messages initially
    setErrorMessage("");

    // Validate input fields
    if (balanceAmountValue < 0) {
      setErrorMessage("Balance amount cannot be less than 0.");
      return;
    }

    // if (discountValue > balanceAmountValue) {
    //   setErrorMessage("Discount amount cannot be greater then balance amount.");
    //   return;
    // }

    if (
      customerOrdersData.balanceAmount > 0 &&
      (!paymentMethodValue || paymentMethodValue.trim() === "")
    ) {
      setErrorMessage("Please select the Payment Method");
      return;
    }

    // Prevent multiple submissions
    if (isSubmitButtonPressed) return;

    setIsSubmitButtonPressed(true);

    // Construct the data object
    const data = {
      ...customerOrdersData,
      paidAmount:
        customerOrdersData.paidAmount + (parseInt(receivedAmountValue) || 0),
      receivedAmount: receivedAmountValue,
      status: statusValue,
      remark: remarkValue,
      balanceAmount: balanceAmountValue,
      discount: discountValue,
      paymentMode: paymentMethodValue,
      editByUserName: userProfileData?.firstName + userProfileData?.lastName,
    };

    // Call the API function
    updateCustomerOldOrderLedger(customerOrdersData.brandId, data)
      .then((response) => {
        if (response.data && !response.data.error) {
          const { message, success } = response.data;

          setModalVisible(true);
          setModalStatus(success ? "success" : "not Success");
          setModalText(message);

          sendResponse({ message, success });

          // Reset UI states after successful update
          setIsSubmitButtonPressed(false);
          setOldOrderInfoEditVisible(false);
          setErrorMessage("");
        } else {
          setIsSubmitButtonPressed(false);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
        setIsSubmitButtonPressed(false);
      });
  };

  const handleModalClose = () => {
    setIsSubmitButtonPressed(false);
    setOldOrderInfoEditVisible(false);
    setErrorMessage("");
    const message = true;
    const success = true;
    sendResponse({
      message,
      success,
    });
  };

  return (
    <div className="flex justify-content-center">
      <Dialog
        modal
        visible={oldOrderInfoEditVisible}
        style={{ width: "50vw" }}
        onHide={() => {
          if (!oldOrderInfoEditVisible) return;
          handleModalClose();
        }}
        content={({ hide }) => (
          <div
            className="flex flex-column "
            style={{
              borderRadius: "12px",
              backgroundColor: "#fff",
            }}
          >
            <div
              className="flex border-round-xl  justify-content-between align-items-center gap-1 px-4 py-2"
              style={{
                backgroundImage:
                  "radial-gradient(circle at left top, #2B70D7, #1752AA)",
              }}
            >
              <div></div>

              <p className=" text-3xl text-primary-50 font-semibold">
                Edit Old Order
              </p>
              <Button
                label="x"
                onClick={(e) => hide(e)}
                text
                className=" text-xl text-primary-50 border-1 p-1"
              ></Button>
            </div>

            {customerOrdersData?.balanceAmount > 0 && (
              <div className="mt-2">
                <div className="flex justify-content-between flex-1 mx-4 mt-4 pb-2 ">
                  <div
                    className="border-round-xl shadow-2 col-md-6 mr-2"
                    style={{
                      backgroundColor: "#fff",
                    }}
                  >
                    <FloatLabel>
                      <InputText
                        id="receivedAmountValue"
                        placeholder="Received Amount"
                        value={receivedAmountValue}
                        maxLength={50}
                        onChange={(e) =>
                          handleReceivedAmountChange(e.target.value)
                        }
                        className="w-full border-none px-3 text-md "
                      ></InputText>
                      <label
                        htmlFor="receivedAmountValue"
                        className="text-lg"
                        style={{ color: "blue" }}
                      >
                        Received Amount <span style={{ color: "red" }}>*</span>
                      </label>
                    </FloatLabel>
                  </div>

                  <div
                    className="border-round-xl shadow-2 col-md-6"
                    style={{
                      backgroundColor: "#fff",
                    }}
                  >
                    <FloatLabel>
                      <InputText
                        id="discountValue"
                        placeholder="Discount"
                        value={discountValue}
                        maxLength={50}
                        onChange={(e) => handleDiscountChange(e.target.value)}
                        className="w-full border-none px-3 text-md "
                      ></InputText>
                      <label
                        htmlFor="discountValue"
                        className="text-lg"
                        style={{ color: "blue" }}
                      >
                        Discount <span style={{ color: "red" }}>*</span>
                      </label>
                    </FloatLabel>
                  </div>
                </div>

                <div className="flex justify-content-between flex-1 mx-4 mt-4 pb-2">
                  <div
                    className="border-round-xl shadow-2 col-md-6 mr-2"
                    style={{
                      backgroundColor: "#fff",
                    }}
                  >
                    <FloatLabel>
                      <InputText
                        id="balanceAmountValue"
                        placeholder="Other Remark"
                        value={balanceAmountValue}
                        disabled={true}
                        className="w-full border-none px-3 text-md "
                      ></InputText>
                      <label
                        htmlFor="balanceAmountValue"
                        className="text-lg"
                        style={{ color: "blue" }}
                      >
                        Balance Amount <span style={{ color: "red" }}>*</span>
                      </label>
                    </FloatLabel>
                  </div>

                  <div
                    className="border-round-xl shadow-2 col-md-6 "
                    style={{
                      backgroundColor: "#fff",
                    }}
                  >
                    <FloatLabel>
                      <Dropdown
                        id="paymentMethodValue"
                        value={paymentMethodValue}
                        onChange={(e) => handlePaymentMethodChange(e.value)}
                        options={paymentModeData}
                        optionLabel="name"
                        placeholder="Payment Method"
                        className="w-full  bg-white-alpha-20  text-2xl text-primary-50 shadow-2"
                      />
                      <label
                        htmlFor="paymentMethodValue"
                        className="text-lg"
                        style={{ color: "blue" }}
                      >
                        Payment Mode <span style={{ color: "red" }}>*</span>
                      </label>
                    </FloatLabel>
                  </div>
                </div>
              </div>
            )}
            <div className="flex-1 mx-4 mt-4">
              <FloatLabel>
                <Dropdown
                  id="statusSuggestionValue"
                  value={statusSuggestionValue}
                  onChange={(e) => handleStatusSuggestionChange(e.value)}
                  options={statusSuggestionData}
                  optionLabel="name"
                  placeholder="Status Suggestion"
                  className="w-full  bg-white-alpha-20  text-2xl text-primary-50 shadow-2"
                />
                <label
                  htmlFor="statusSuggestionValue"
                  className="text-lg"
                  style={{ color: "blue" }}
                >
                  Status Suggestion <span style={{ color: "red" }}>*</span>
                </label>
              </FloatLabel>
            </div>
            <div className="flex-1 mx-4" style={{ marginTop: 30 }}>
              <div
                className="border-round-xl shadow-2"
                style={{
                  backgroundColor: "#fff",
                }}
              >
                <FloatLabel>
                  <InputText
                    id="statusValue"
                    placeholder="Status"
                    value={statusValue}
                    maxLength={50}
                    onChange={(e) => handleStatusChange(e.target.value)}
                    className="w-full border-none px-3 text-md "
                  ></InputText>
                  <label
                    htmlFor="statusValue"
                    className="text-lg"
                    style={{ color: "blue" }}
                  >
                    Status <span style={{ color: "red" }}>*</span>
                  </label>
                </FloatLabel>
              </div>
            </div>

            <div className="flex-1 mx-4" style={{ marginTop: 30 }}>
              <div
                className="border-round-xl shadow-2"
                style={{
                  backgroundColor: "#fff",
                }}
              >
                <FloatLabel>
                  <InputText
                    id="remarkValue"
                    placeholder="Other Remark"
                    value={remarkValue}
                    maxLength={50}
                    onChange={(e) => handleRemarkChange(e.target.value)}
                    className="w-full border-none px-3 text-md "
                  ></InputText>
                  <label
                    htmlFor="remarkValue"
                    className="text-lg"
                    style={{ color: "blue" }}
                  >
                    Remark
                  </label>
                </FloatLabel>
              </div>
            </div>

            <Button
              disabled={isSubmitButtonPressed}
              onClick={onUpdateButtonPress}
              className="my-2 mx-4 border-round-xl "
            >
              <p className=" w-full text-2xl  font-semibold flex justify-content-center">
                Update
              </p>
            </Button>
            {errorMessage && (
              <div style={{ alignSelf: "center" }}>
                <p className="text-lg font-normal" style={{ color: "red" }}>
                  {errorMessage}
                </p>
              </div>
            )}
          </div>
        )}
      ></Dialog>
      <div>
        <SuccessModal
          modalVisible={modalVisible}
          setModalVisible={setModalVisible}
          status={modalStatus}
          text={modalText}
        />
      </div>
    </div>
  );
};

export default OldOrderInfoEdit;
